import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { PurposeCreationIntent } from '../../../../graphql/schema';
import { NameAndImage } from '../../NameAndImage';
import { nameAndImage } from '../../sharedSchemas';
import { useRetirementStep } from '../FlowConfig';

type FormValues = Yup.InferType<typeof nameAndImage>;

export const RetirementNameAndImageStep: React.FC = () => {
  const navigate = useNavigate();
  const { flowId } = useParams<{ flowId: string }>();

  const { commit } = useRetirementStep('nameAndImage');

  const handleSubmit = (formValues: FormValues) => {
    commit(formValues);
    void navigate(`/add_purpose/retirement/${flowId}/retirement_selection`);
  };

  return <NameAndImage handleSubmit={handleSubmit} intent={PurposeCreationIntent.Retirement} />;
};
